import React, { useState, useEffect } from "react";
import { Menu, Sidebar, MenuItem } from "react-pro-sidebar";
import { useProSidebar } from "react-pro-sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  IconButton,
  Collapse,
  Radio,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
  Avatar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import SellIcon from '@mui/icons-material/Sell';
import EditNoteIcon from '@mui/icons-material/EditNote';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import CloseIcon from "@mui/icons-material/Close";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import GroupsIcon from '@mui/icons-material/Groups';
import PostAddIcon from '@mui/icons-material/PostAdd';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { GlobalStyles } from "@mui/system";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useAuth } from "../../../AuthProvider";
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import GroupIcon from '@mui/icons-material/Group';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import StoreIcon from '@mui/icons-material/Store';
import ArticleIcon from '@mui/icons-material/Article';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import FolderIcon from '@mui/icons-material/Folder';
import EventIcon from "@mui/icons-material/Event";
import DiscountIcon from '@mui/icons-material/Discount';
import AssignmentIcon from "@mui/icons-material/Assignment";
import TimelineIcon from "@mui/icons-material/Timeline";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import SchoolIcon from "@mui/icons-material/School";
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import BarChartIcon from "@mui/icons-material/BarChart";
import ScheduleIcon from '@mui/icons-material/Schedule';
import { BookOpenText ,SquarePen,BookUp2,FlaskConical ,NotebookPen,ClockAlert, NotepadText ,Bell ,Keyboard ,MessageCircleWarning ,Boxes,MessageSquareWarning ,Clock4 ,ClockArrowUp ,Users ,UsersRound ,UserRoundX ,UserRoundPen,ReceiptIndianRupee  , Bus ,Layers ,ShoppingCart ,UserCog ,UserPen,UserPlus ,UserMinus,BusFront ,MailOpen     } from 'lucide-react';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import { FaRupeeSign,FaFileInvoice  } from "react-icons/fa";
import { GiUpgrade } from "react-icons/gi";
import { MdOutlineTransferWithinAStation } from "react-icons/md";
import { TbCertificate } from "react-icons/tb";
import { GiExpense } from "react-icons/gi";
import { MdDoNotDisturb } from "react-icons/md";
import { GrCertificate } from "react-icons/gr";
import { FaCertificate } from "react-icons/fa6";
import { FaWpforms } from "react-icons/fa";

import PersonIcon from '@mui/icons-material/Person';
// import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import PaymentIcon from "@mui/icons-material/Payment";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import EventNoteIcon from "@mui/icons-material/EventNote";
// import "./sidebar.css";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";

import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";

//Bus Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import RouteIcon from '@mui/icons-material/Route';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

//Present
import DoneIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';
import PaymentsIcon from '@mui/icons-material/Payments';
import PaidIcon from '@mui/icons-material/Paid';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import BusAlertIcon from '@mui/icons-material/BusAlert';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import ChatIcon from '@mui/icons-material/Chat';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';

const MyProSidebar = () => {
   const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { collapseSidebar, toggleSidebar,collapsed, broken } = useProSidebar();
  // const { collapseSidebar, toggleSidebar, collapsed, broken } = useProSidebar();
  const navigate = useNavigate();
  const location = useLocation();
   const { role, refreshKey, oId ,pId,plan,feature,setOrgName} = useAuth();
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(true); // State to control submenu visibility
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [title, setTitle] = useState("Principal");
  const [registeredRoles, setregisteredRoles] = useState([]); // State to store roles
  const [examTypes, setExamTypes] = useState([]);
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const [featureEnable, setFeaturesEnable] = useState([]);        // fetched features
  const [principals, setPrincipals] = useState([]);
  const [principalloading, setPrincipalLoading] = useState(true); // optional: for loading state
  const [availableTypes, setAvailableTypes] = useState([]);

  const [selectedSubmenu, setSelectedSubmenu] = useState(() => {
    // Initialize selectedSubmenu from sessionStorage
    return sessionStorage.getItem("selectedSubmenu") || "/PrincipalDashboard";
  });


  const [companyInfo, setCompanyInfo] = useState({
    schoolLogo: "",
    schoolName: "",
  });

  setOrgName(companyInfo.schoolName);
 

  // Fetch company info
  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
       
        const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCompanyInfo({
          schoolLogo: data?.schoolLogo || "",
          schoolName: data?.schoolName || "Unknown Company",
        });
      } catch (error) {
        console.error("Error fetching company info:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanyInfo();
  }, [oId, refreshKey.companyInfo]);

 
     useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/v1/organisation/getFeatureEnable/${oId}`);
        if (!response.ok) {
          throw new Error("Failed to fetch features");
        }
        const data = await response.json();
        // assuming API returns something like [{id:1,name:'Attendance'}, {id:2,name:'Fee'}]
        setFeaturesEnable(data || []);
      } catch (error) {
        console.error("Error fetching features:", error);
      } 
    };

    fetchFeatures();
  }, []);


   // Fetch Registered roles info
   
    const fetchRegisteredRoles = async () => {
      try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const response = await fetch(`${baseUrl}/api/principal/unique-user-role-names/${oId}/${pId}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        // Filter out STORE_DEPARTMENT
        // const filteredRoles = data.filter(role => role !== "STORE_DEPARTMENT");

        setregisteredRoles(data);
        // setregisteredRoles(data); // Set the fetched roles to the state
      } catch (error) {
        console.error("Error fetching roles:", error);
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
      if (isPrincipal) {
     fetchRegisteredRoles();
  }
   
  }, [refreshKey.registeredRoles]);

  // Fetch Examination info dynamic (fa1,fa2)
  
    const fetchExamTypes = async () => {
      try {
        
        const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllExamsTypes/${oId}/${pId}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        // Convert ["A", "B", "C"] to [{ Examtype: "A" }, ...]
        const formattedData = data.map(type => ({ Examtype: type }));
        setExamTypes(formattedData);
      } catch (error) {
        console.error("Error fetching exam types:", error);
      } finally {
        setLoading(false);
      }
    };

 useEffect(() => {
  if (role !== "ORGANIZATION" && role !== "SUPERADMIN") {
    fetchExamTypes();
  }
}, [role, refreshKey.examTypes]);


  const Examination = examTypes.map(exam => ({
  Examtype: exam.Examtype
}));

// 🟢 Fetch Question Types
const fetchQuizTypes = async () => {
  try {
    const res = await fetch(`${baseUrl}/api/online/exam/types/${pId}`);
    if (!res.ok) throw new Error("Failed to fetch Test types");
    const data = await res.json();

    if (data && data.length > 0) {
      setAvailableTypes(data);
    }
  } catch (error) {
    console.error("Error fetching question types:", error);
    // toast.error("Failed to load question types!", { autoClose: 2000 });
  }
};

// 🟢 Load types and questions on mount
useEffect(() => {
  fetchQuizTypes();
}, [refreshKey.quizTypes]);

const fetchAllPrincipals = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/principal/getAllPrincipals/${oId}`);

    if (!response.ok) {
      console.error("Failed to fetch principal data");
      setPrincipals([]); // fallback to empty
      return;
    }

    const data = await response.json();

    if (!Array.isArray(data) || data.length === 0) {
      console.warn("No principal data found.");
      setPrincipals([]); // no crash
      return;
    }

    setPrincipals(data); // valid array of principals

  } catch (error) {
    console.error("Error fetching principals:", error);
    setPrincipals([]); // on error fallback
  }
};

useEffect(() => {
  if (role === "ORGANIZATION"){
    fetchAllPrincipals(); // only run if oId is valid
  } 
}, [oId, refreshKey.principals]);





  const getPrincipalSubmenu = (registeredRoles) => {
    const roleToMenu = {
      EXAMINATION_CELL: { title: "Examination", to: "/ExaminationDashboard" },
      HRBP: { title: "HRBP", to: "/Dashboard" },
      ADMISSION_FEE: { title: "Admission", to: "/Admission_DashBoard" },
      SCHEDULE_MEETING: { title: "Schedule&Meets", to: "/ScheduleAndMeetDashboard" },
      STORE_DEPARTMENT: { title: "Store", to: "/StoreDashboard" },
      TRANSPORT: { title: "Transport", to: "/TransportDashboard" },
    };
  
    const submenu = [
      { title: "Principal", to: "/PrincipalDashboard" },
      // { title: "HRBP Dashboard", to: "/Dashboard" },
    ];
  
    registeredRoles.forEach((role) => {
      if (roleToMenu[role]) {
        submenu.push(roleToMenu[role]);
      }
    });
  
    return submenu;
  };



  

  const menuItems = {


  SUPERADMIN: [
     
      {
        title: 'Dashboard',
        icon: <DashboardCustomizeOutlinedIcon />,
         to: '/SuperAdminDashboard',
      },
      {
        title: 'Packages',
        icon: <DiscountIcon />,
         to: '/Packages',
      },
      {
        title: 'Add Feature',
        icon: <PlaylistAddIcon />,
         to: '/AddFeatureList',
      },
      
      
      
    ],




    ORGANIZATION: [
     
      {
        title: 'DashBoard',
        icon: <DashboardCustomizeOutlinedIcon />,
        to: '/OrganizationDashboard',
      },
     
     
       {
          title: 'Principals',
          icon: <PeopleAltIcon />,
          to: '/PrincipalsList',
          submenu: principals.map((principal) => ({
            title: `${principal.firstName} ${principal.lastName}`,
            icon: <PersonIcon />,
            to: `/PrincipalDashboard/${principal.prId}`,
            
          })),
        },

      
    ],



    PRINCIPAL: [
      {
        title: `${title}`,
        icon: <DashboardCustomizeOutlinedIcon />,
        submenu: getPrincipalSubmenu(registeredRoles),
      },
    ],

    //ScheduleAndMeetDashboard
    SCHEDULE_MEETING:[
      {
        title: 'DashBoard',
        icon: <DashboardCustomizeOutlinedIcon />,
        to: '/ScheduleAndMeetDashboard',
      },
      
      {
        title: 'Teacher Schedule',
        icon: <ClockArrowUp />,
        to: '/TeachersClassSchedule',
      },
      {
        title: 'Assign ClassTeacher',
        icon: <GroupAddIcon />,
        to: '/ClassTeachersList',
      },
      {
        title: 'Class Schedule',
        icon: <Clock4 />,
        to: '/AllClassSchedules',
      },
      {
        title: 'Meetings',
        icon: <Users />,
        to: '/TeacherMeeting',
        submenu: [
           
          {
            title: 'Teacher Meetings',
            icon: <UserRoundPen />,
            to: '/TeacherMeeting',
          },
          {
            title: 'Parents Meeting',
            icon: <UsersRound />,
            to: '/ParentMeetings',
          },
          {
            title: 'Non-Teaching Staff',
            icon: <UserRoundX />,
            to: '/NonTeachingStaffMeetings',
          },
         
          
        ],
      },
       {
        title: 'Digital Classes',
        icon: <Bell />,
        to: '/DigitalClasses',
      },
      {
        title: 'Notifications',
        icon: <Bell />,
        to: '/Notification',
      },
      {
        title: 'Notice Board',
        icon: <AssignmentOutlinedIcon />,
        to: '/ScheduleNoticeBoard',
      },
      // {
      //   title: 'Complaints',
      //   icon: <MessageCircleWarning />,
      //   to: '/IndividualComplaintsList',
      // },
      
      
    ],

    EXAMINATION_CELL: [

      {
        title: 'Dashboard',
        icon: <DashboardCustomizeOutlinedIcon />,
        to: '/ExaminationDashboard',
      },
     
     
      {
        title: "Schedule",
        icon: <ScheduleIcon/>,
        to: "/AllExaminationScheduleList",
      },
      {
        title: "Ongoing",
        icon: <BookUp2 />,
        to: "/TodayandTmrwExaminationScheduleList",
      },
      // {
      //   title: "Assign Marks",
      //   icon: <LocalLibraryIcon />,
      //   to: "/AssigenedExamSubjectMarksList",
      // },
      {
        title: "Assign Marks",
        icon: <LocalLibraryIcon />,
        to: "/AssigenedExamSubjectMarksList",
      },
      {
        title: "Upload Marks",
        icon: <UploadFileIcon />,
        // to: "/StudentMarksUpload",
        to: "/StudentMarksList",
      },
      
     

     {
                title: 'Academics',
                icon: <BookOpenText />,
                // to: '/PrincipalsList',
                submenu: Examination.map((exam) => ({
                  title: exam.Examtype,
                  icon: <NotepadText />,
                  to: `/ExaminationMiniDashboard/${exam.Examtype}`,
                })),
              },

     


      {
        title: 'Notifications',
        icon: <Bell  />,
        to: '/Notification',
      },
      {
        title: 'Notice Board',
        icon: <AssignmentOutlinedIcon />,
        to: '/ScheduleNoticeBoard',
      },

      // {
      //   title: "Complaints",
      //   icon: <MessageCircleWarning  />,
      //   to: "/IndividualComplaintsList",
      // },

      
     
     
      
    ],

    ADMISSION_FEE: [
     
      {
        title: 'DashBoard',
        icon: <DashboardCustomizeOutlinedIcon />,
        to: '/Admission_DashBoard',
      },
     
      
      {
        title: 'Admission Form',
        icon: <PostAddIcon />,
        to:'/NewAdmissionForm'
      },
      {
        title: 'Students',
        icon: <GroupsIcon />,
        // to: '/Expenses',
        submenu: [
          {
            title: 'All Students',
            icon: <GroupsIcon />,
            to:'/AllStudentList'
          },
          
          // {
          //   title: 'Student Promotion',
          //   icon: <GiUpgrade />,
          //    to:'/StudentPromotionList'
          // },
          // {
          //   title: 'Student Transfer',
          //   icon: <MdOutlineTransferWithinAStation />,
          //    to:'/StudentTransferList'
          //     // to:'/StudentTransferList'
          // },
          // {
          //   title: 'Branch Transfer',
          //   icon: <SwapHorizIcon />,
          //   to: '/StudentBranchTransferList',
          // }
         
        ],
      },

      {
        title: 'Admission Fee',
        icon: <PostAddIcon  />,
        to:'/AdmissionFeePayments'
      },
     
     
      {
        title: 'Tuition Fees',
        icon: <ReceiptIndianRupee />,
        to: '/FeesDetailsList',
        submenu: [
          {
        title: 'Concession Fee',
        icon: <PostAddIcon  />,
        to:'/StudentFeeConcessionList'
      },
          
          {
            title: 'Paid Fees',
            icon: <FaRupeeSign />,
            to: '/PaidFeesList',
          },
          {
            title: 'UnPaid Fees',
            icon: <DoNotDisturbAltIcon />,
            to: '/UnPaidFeesList',
          },
          
        ],
      },
      
      // {
      //   title: 'Bus Fees',
      //   icon: <Bus/>,
      //   to: '/BusFeesDetailsList',
      //   submenu: [
      //      {
      //       title: 'Concession Fee',
      //       icon: <PostAddIcon  />,
      //       to:'/BusFeeConcessionList'
      //     },
         
         
      //     {
      //       title: 'Paid Bus Fees',
      //       icon: <FaRupeeSign />,
      //       to: '/PaidBusFeeList',
      //     },
      //     {
      //       title: 'UnPaid Bus Fees',
      //       icon: <DoNotDisturbAltIcon />,
      //       to: '/UnpaidBusFeeList',
      //     },
          
      //   ],
      // },
    ...(feature === "CORE" || feature === "ULTRA"
      ? [
          {
        title: 'Bus Fees',
        icon: <Bus/>,
        to: '/BusFeesDetailsList',
        submenu: [
          {
            title: 'Concession Fee',
            icon: <PostAddIcon  />,
            to:'/BusFeeConcessionList'
          },
         
          {
            title: 'Paid Bus Fees',
            icon: <FaRupeeSign />,
            to: '/PaidBusFeeList',
          },
          {
            title: 'UnPaid Bus Fees',
            icon: <DoNotDisturbAltIcon />,
            to: '/UnpaidBusFeeList',
          },
          
        ],
      },
        ]
      : []), // Don't include 'Packages' if not ULTRA

      {
            title: 'Exam Fees',
            icon: <FaRupeeSign   />,
            to: '/ExamFees',
          },
            ...(feature === "CORE" || feature === "ULTRA"
      ? [
         {
        title: 'Hostel Fee',
        icon: <AddBusinessIcon  />,
        to: '/HostelFeesList',
      },
        ]
      : []), // Don't include 'Packages' if not ULTRA

      {
        title: 'Additional Fee',
        icon: <LocalLibraryIcon    />,
        to: '/BooksFeeList',
      },
      //   // {
        //   //   title: 'Other Fees',
        //   //   icon: <DoNotDisturbAltIcon />,
        //   //   to: '/OtherFees',
        //   // },
      
       {
        title: 'All Payments',
        icon: <ReceiptIndianRupee  />,
        to: '/FeePayments',
      
      },
    
      {
        title: 'Expenses',
        icon: <AssuredWorkloadIcon />,
        to: '/Expenses',
      },
       {
        title: 'Student Attendance',
        icon: <GroupAddIcon />,
        to: '/StudentAttendance',
      },
     
      {
        title: 'Bonafide ',
        icon: <FaCertificate />,
        to: '/BonafideCertificate',
      },
      // {
      //   title: 'Fee Receipt ',
      //   icon: <FaCertificate    />,
      //   to: '/FeeReceipt',
      // },
      
      {
        title: 'Notice Board',
        icon: <AssignmentOutlinedIcon />,
        to: '/ScheduleNoticeBoard',
      },
      {
        title: 'Notifications',
        icon: <Bell />,
        to: '/Notification',
      },
      // {
      //   title: 'Complaints',
      //   icon: <MessageCircleWarning />,
      //   to: '/IndividualComplaintsList',
      // },
      
      {
        title: 'Reports',
        icon: <MessageSquareWarning />,
        to: '/AdmissionReportsScreen',
      },


    ],

    STORE_DEPARTMENT: [
      {
        title: 'Store_DashBoard',
        icon: <DashboardCustomizeOutlinedIcon />,
        to: '/StoreDashboard',
      },
     

        {
        title: 'Purchase',
        icon: <ShoppingCart />,
        to: '/PurchaseInvoiceList',
        // submenu: [
          
        //   {
        //     title: 'Payments Out',
        //     icon: <AccountBalanceWalletIcon />,
        //     to: '/Accounts_PaymentsOut',
        //   },
        //   {
        //     title: 'Paid List',
        //     icon: <FaRupeeSign />,
        //     color: 'blue',
        //     to: '/Accounts_PurchasePaidList',
            
        //   },
        //   {
        //     title: 'UnPaid List',
        //     icon: <MdDoNotDisturb />,
        //     color: 'blue',
        //     to: '/Accounts_PurchaseUnPaidList',
          
        //   },
        // ],
        
      },
      
      {
        title: 'Stock Items',
        icon: <AddBusinessIcon />,
        to: '/StockItems',
        
      },
      {
        title: 'Students List',
        icon: <GroupsIcon />,
        to: '/StoreTotalStudentsList',
        
      },
      {
        title: 'Sold Items List',
        icon: <SellIcon />,
        to: '/SoldItems',
        
      },

    

    
      {
        title: 'Expenses',
        icon: <AssuredWorkloadIcon />,
        to: '/Store_Expenses',
      },
  
      // {
      //   title: 'Complaints',
      //   icon: <MessageCircleWarning />,
      //   to: '/IndividualComplaintsList',
      // },
      {
        title: 'Notifications',
        icon: <Bell />,
        to: '/Notification',
      },
      {
        title: 'Notice Board',
        icon: <AssignmentOutlinedIcon />,
        to: '/ScheduleNoticeBoard',
      },

      {
          title: 'Reports',
          icon: <MessageSquareWarning />,
          to: '/StoreReportsScreen',
        },
    ],

    TRANSPORT:[
      {
        title: 'Dashboard',
        icon: <DashboardCustomizeOutlinedIcon />,
        to: '/TransportDashboard',
      },
      
      
      {
        title: 'Scheduling Route',
        icon: <Clock4  />,
        to: '/SchedulingRouteList',
      },
      {
          title: 'Trips',
          icon: <Bus  />,
          to: '/Trips',
        },
      {
        title: 'Drivers',
        icon: <UserCog />,
        to: '/DriversList',
      },
      {
        title: 'Student Bus List',
        icon: <UserPen/>,
        to: '/TotalBusAttendanceList',
        submenu: [
         
          {
            title: 'Present Students',
            icon: <UserPlus />,
            to: '/PresentBusAttendeesList',
          },
          {
            title: 'Absent Students',
            icon: <UserMinus />,
            to: '/AbsentBusAttendeesList',
          },
          
        ],
      },
      
      {
        title: 'Bus Fees',
        icon: <Bus />,
        to: '/BusFeesDetailsList',
        submenu: [
         
          {
            title: 'Paid Bus Fees',
            icon: <FaRupeeSign />,
            to: '/PaidBusFeeList',
          },
          {
            title: 'UnPaid Bus Fees',
            icon: <DoNotDisturbAltIcon />,
            to: '/UnpaidBusFeeList',
          },
          
        ],
      },
      
      {
        title: 'Bus Expenses',
        icon: <AssuredWorkloadIcon />,
        to: '/BusExpenses',
      },
      {
        title: 'Notice Board',
        icon: <AssignmentOutlinedIcon />,
        to: '/ScheduleNoticeBoard',
      },
      
      {
        title: 'Notifications',
        icon: <Bell />,
        to: '/Notification',
      },
      // {
      //   title: 'Complaints',
      //   icon: <MessageCircleWarning />,
      //   to: '/IndividualComplaintsList',
      // },
     
      {
        title: 'Reports',
        icon: <MessageSquareWarning />,
        to: '/TransportReportsScreen',
      },
    
  ],

  HRBP:[

    // "/Dashboard": [
      {
        title: 'Dashboard',
        icon: <DashboardCustomizeOutlinedIcon />,
        to: '/Dashboard',
      },
      {
        title: 'Employees',
        icon: <GroupAddIcon />,
        to: '/Employee',
      },
      {
        title: 'Attendance',
        icon: <FingerprintIcon />,
        to: '/EmployeeAttendance',
      },
      {
        title: 'Leave Management',
        icon: <MailOpen  />,
        to: '/EmployeeLeave',
      },
      {
        title: 'Holidays List',
        icon: <CalendarMonthIcon />,
        to: '/HolidayCalendar',
      },
      {
        title: 'Payroll',
        icon: <ReceiptLongIcon />,
        to: '/EmployeePaySlip',
      },
      {
        title: 'Notice Board',
        icon: <AssignmentOutlinedIcon />,
        to: '/ScheduleNoticeBoard',
      },
      {
        title: 'Reports',
        icon: <MessageSquareWarning />,
        to: '/HRBPReportsScreen',
      },
      
    

  ]


  };

 

  const relatedItems = {

   "/PrincipalDashboard": [

    {
        title: 'Role Registrations',
         icon: <GroupsIcon  />,
        to: '/RoleRegistrationList',
      },

      {
        title: 'Employees',
        icon: <GroupAddIcon />,
        to: '/Employee',
      },

      {
        title: 'Notice Board',
        icon: <AssignmentOutlinedIcon />,
        to: '/NoticeBoard',
      },

      {
        title: 'Notifications',
        icon: <Users  />,
        to: '/TeacherMeeting',
        submenu: [
           
          {
            title: 'Teacher Notification',
            icon: <UserRoundPen   />,
            to: '/TeacherMeeting',
          },
          {
            title: 'Parents Notification',
            icon: <UsersRound  />,
            to: '/ParentMeetings',
          },
          {
            title: 'Non-Teaching Staff',
            icon: <UserRoundX  />,
            to: '/NonTeachingStaffMeetings',
          },
          
        ],
      },
      {
        title: 'Complaints',
        icon: <MessageCircleWarning />,
        to: '/Complaint',
       
      },
      
      {
        title: 'Concession Fee',
        icon: <AssignmentIcon />,
        to: "/ConcessionFeeList",
        submenu: [
          {
        title: 'Tution Fee',
        icon: <PostAddIcon />,
        to: '/ConcessionFeeList',
      },
       ...((feature === "CORE" || feature === "ULTRA")? [
          {
        title: 'Bus Fee',
        icon: <PostAddIcon />,
        to: '/ConcessionBusFeeList',
      },
        ]: []), // Don't include 'Packages' if not ULTRA



        ]
      },
     
   ...(feature === "ULTRA"
      ? [
         {
        title: 'Bus Tracking',
        icon: <DirectionsBusIcon />,
        to: '/BusTracking',
      },
        ]
      : []), // Don't include 'Packages' if not ULTRA

       
       
      {
        title: 'Modify Payment',
        icon: <FaRupeeSign />,
        // to: '/Expenses',
        submenu: [
          {
        title: 'Tution Fee List',
        icon: <ReceiptIndianRupee />,
        to: '/PrincipalEditTuitionFeeList',
        },
        {
        title: 'Bus Fee List',
        icon: <Bus />,
        to: '/PrincipalEditBusFeeList',
      },
      {
        title: 'Hostel Fee List',
        icon: <Bus />,
        to: '/PrincipalEditHostelfeeList',
      },
    ],
  },

    // {
    //     title: 'Summary Report',
    //     icon: <NewspaperIcon />,
    //     to: '/OverAllReports',
    //   },
    
     ...(featureEnable.includes("Summary Report")
      ? [
         {
        title: 'Summary Report',
        icon: <NewspaperIcon />,
        to: '/OverAllReports',
      },
        ]
      : []), //  include 'Summary Report' 

     

      {
        title: 'Student Attendance',
        icon: <GroupAddIcon />,
        to: '/StudentAttendance',
      },

  
//  {
//                 title: 'Talent Test',
//                 icon: <NoteAltIcon />,
//                 to: '/QuestionFormCard',
//                 submenu: availableTypes.map((Test) => ({
//                   title: Test,
//                   icon: <EditNoteIcon />,
//                   to: `/TalentTestMiniDashboard/${Test}`,
//                 })),
//         },
        

          ...(featureEnable.includes("Talent Test")
      ? [
      {
                title: 'Talent Test',
                icon: <NoteAltIcon />,
                to: '/QuestionFormCard',
               submenu: availableTypes.map((Test) => ({
  title: Test,
  icon: <EditNoteIcon />,
  to: `/TalentTestMiniDashboard/${encodeURIComponent(Test)}`,
}))
        },
        ]
      : []), 
     
    
       {
        title: 'Leisure Period',
        icon: <GroupAddIcon />,
        to: '/LeisurePeriod',
      },

  {
        title: 'Student List',
        icon: <PlaylistAddIcon />,
         to: '/StudentApplicationList',
      },

      {
        title: 'Reports',
        icon: <MessageSquareWarning  />,
        to: '/PrincipalReports',
      },

     
      // {
      //   title: 'Marketing',
      //   icon: <PlaylistAddIcon />,
      //   //  to: '/Marketing',
      //     submenu: [
           
      //           {
      //             title: 'Marketing',
      //             icon: <PlaylistAddIcon />,
      //             to: '/Marketing',
      //           },
      //            {
      //             title: 'E-Commerce',
      //             icon: <PlaylistAddIcon />,
      //             to: '/Ecommerce',
      //           },
      //            {
      //             title: 'Estore',
      //             icon: <PlaylistAddIcon />,
      //             to: '/Estore',
      //           },
      //            {
      //             title: 'B2b',
      //             icon: <PlaylistAddIcon />,
      //             to: '/EDashboard',
      //           },
      //           {
      //             title: 'StoreB2b',
      //             icon: <PlaylistAddIcon />,
      //             to: '/Home',
      //           },
      //     ]
      // },

      

    ],

   "/Dashboard": [
      
      {
        title: 'Employees',
        icon: <GroupAddIcon />,
        to: '/Employee',
      },
      {
        title: 'Attendance',
        icon: <FingerprintIcon />,
        to: '/EmployeeAttendance',
      },
      {
        title: 'Leave Management',
        icon: <MailOpen  />,
        to: '/EmployeeLeave',
      },
      {
        title: 'Holidays List',
        icon: <CalendarMonthIcon />,
        to: '/HolidayCalendar',
      },
      {
        title: 'Payroll',
        icon: <ReceiptLongIcon />,
        to: '/EmployeePaySlip',
      },
      // {
      //   title: 'Reports',
      //   icon: <MessageSquareWarning />,
      //   to: '/HRBPReportsScreen',
      // },
      
    ],

   "/ExaminationDashboard":[
      {
        title: "Schedule",
        icon: <ScheduleIcon />,
        to: "/AllExaminationScheduleList",
      },
      {
        title: "Ongoing",
        icon: <BookUp2 />,
        to: "/TodayandTmrwExaminationScheduleList",
      },
      
       {
        title: "Assign Marks",
        icon: <LocalLibraryIcon />,
        to: "/AssigenedExamSubjectMarksList",
      },
      {
        title: "Upload Marks",
        icon: <UploadFileIcon />,
        // to: "/StudentMarksUpload",
        to: "/StudentMarksList",
      },
      // {
      //   title: "Report card",
      //   icon: <BookUp2 />,
      //   to: "/StudentReportCard",
      // },
      
         {
                title: 'Academics',
                icon: <BookOpenText />,
                // to: '/PrincipalsList',
                submenu: Examination.map((exam) => ({
                  title: exam.Examtype,
                  icon: <NotepadText />,
                  to: `/ExaminationMiniDashboard/${exam.Examtype}`,
                })),
              },

      
    ],


    "/StoreDashboard": [

        {
        title: 'Purchase',
        icon: <ShoppingCart  />,
        to: '/PurchaseInvoiceList',
        // submenu: [
          
        //   {
        //     title: 'Payments Out',
        //     icon: <AccountBalanceWalletIcon />,
        //     to: '/Accounts_PaymentsOut',
        //   },
        //   {
        //     title: 'Paid List',
        //     icon: <FaRupeeSign />,
        //     color: 'blue',
        //     to: '/Accounts_PurchasePaidList',
            
        //   },
        //   {
        //     title: 'UnPaid List',
        //     icon: <MdDoNotDisturb  />,
        //     color: 'blue',
        //     to: '/Accounts_PurchaseUnPaidList',
          
        //   },
        // ],
      },
       {
        title: 'Stock Items',
        icon: <AddBusinessIcon  />,
        to: '/StockItems',
        
      },
      {
        title: 'Students List',
        icon: <GroupsIcon />,
        to: '/StoreTotalStudentsList',
        
      },
      {
        title: 'Sold Items List',
        icon: <SellIcon />,
        to: '/SoldItems',
        
      },
     
      // {
      //   title: 'Invoice',
      //   icon: <ReceiptIcon  />,
      //   to: '/AccountsInvoiceList',
      //   submenu: [
         
      //     {
      //       title: 'Payments In',
      //       icon: <PaymentsIcon />,
      //       to: '/Accounts_PaymentsIn',
      //     },
      //     {
      //       title: 'Paid List',
      //       icon: <FaRupeeSign />,
      //       color: 'blue',
      //       to: '/Accounts_PaidList',
          
      //     },
      //     {
      //       title: 'UnPaid List',
      //       icon: <MdDoNotDisturb  />,
      //       color: 'blue',
      //       to: '/Accounts_UnPaidList',
            
      //     },
      //   ],
        
      // },


    

    
      {
        title: 'Expenses',
        icon: <AssuredWorkloadIcon  />,
        to: '/Store_Expenses',
      },
  
      
      
      // {
      //     title: 'Reports',
      //     icon: <MessageSquareWarning  />,
      //     to: '/StoreReports',
      //   },
    ],


    "/Admission_DashBoard": [
     
      
      {
        title: 'Admission Form',
        icon: <PostAddIcon  />,
        to:'/NewAdmissionForm'
      },
      {
        title: 'Students',
        icon: <GroupsIcon />,
        
        submenu: [
          {
            title: 'All Students',
            icon: <GroupsIcon />,
            to:'/AllStudentList'
          },
          
          // {
          //   title: 'Student Promotion',
          //   icon: <GiUpgrade  />,
          //    to:'/StudentPromotionList'
          // },
          // {
          //   title: 'Student Transfer',
          //   icon: <MdOutlineTransferWithinAStation  />,
          //    to:'/StudentTransferList'
          // },
          // {
          //   title: 'Branch Transfer',
          //   icon: <SwapHorizIcon />,
          //   to: '/StudentBranchTransferList',
          // }
         
        ],
      },
     {
        title: 'Admission Fee',
        icon: <PostAddIcon  />,
        to:'/AdmissionFeePayments'
      },
    
      {
        title: 'Tuition Fees',
        icon: <ReceiptIndianRupee  />,
        to: '/FeesDetailsList',
        submenu: [
          {
            title: 'Concession Fee',
            icon: <PostAddIcon  />,
            to:'/StudentFeeConcessionList'
          },
          
          {
            title: 'Paid Fees',
            icon: <FaRupeeSign   />,
            to: '/PaidFeesList',
          },
          {
            title: 'UnPaid Fees',
            icon: <DoNotDisturbAltIcon />,
            to: '/UnPaidFeesList',
          },
          
        ],
      },
       
  

         ...(feature === "CORE" || feature === "ULTRA"
      ? [
          {
        title: 'Bus Fees',
        icon: <Bus/>,
        to: '/BusFeesDetailsList',
        submenu: [
          {
            title: 'Concession Fee',
            icon: <PostAddIcon  />,
            to:'/BusFeeConcessionList'
          },
         
          {
            title: 'Paid Bus Fees',
            icon: <FaRupeeSign />,
            to: '/PaidBusFeeList',
          },
          {
            title: 'UnPaid Bus Fees',
            icon: <DoNotDisturbAltIcon />,
            to: '/UnpaidBusFeeList',
          },
          
        ],
      },
        ]
      : []), // Don't include 'Packages' if not ULTRA
      {
            title: 'Exam Fees',
            icon: <FaRupeeSign   />,
            to: '/ExamFees',
          },

             ...(feature === "CORE" || feature === "ULTRA"
      ? [
         {
        title: 'Hostel Fee',
        icon: <AddBusinessIcon  />,
        to: '/HostelFeesList',
      },
        ]
      : []), // Don't include 'Packages' if not ULTRA

      {
        title: 'Additional Fee',
        icon: <LocalLibraryIcon    />,
        to: '/BooksFeeList',
      },
      // {
      //       title: 'Other Fees',
      //       icon: <DoNotDisturbAltIcon />,
      //       to: '/OtherFees',
      //     },


      {
        title: 'All Payments',
        icon: <ReceiptIndianRupee  />,
        to: '/FeePayments',
      },
      {
        title: 'Student Attendance',
        icon: <GroupAddIcon />,
        to: '/StudentAttendance',
      },
      
      {
        title: 'Bonafide ',
        icon: <FaCertificate    />,
        to: '/BonafideCertificate',
      },
      // {
      //   title: 'Fee Receipt ',
      //   icon: <FaCertificate    />,
      //   to: '/FeeReceipt',
      // },
      {
        title: 'Expenses',
        icon: <AssuredWorkloadIcon  />,
        to: '/Expenses',
      },
      // {
      //   title: 'Expenses',
      //   icon: <AssuredWorkloadIcon />,
      //   to: '/Expenses',
      // },


    ],

   "/ScheduleAndMeetDashboard":[
      
      {
        title: 'Teacher Schedule',
        icon: <ClockArrowUp  />,
        to: '/TeachersClassSchedule',
      },
      {
        title: 'Assign ClassTeacher',
        icon: <GroupAddIcon />,
        to: '/ClassTeachersList',
      },
      {
        title: 'Class Schedule',
        icon: <Clock4   />,
        to: '/AllClassSchedules',
      },
      // {
      //   title: 'Meetings',
      //   icon: <Users  />,
      //   to: '/TeacherMeeting',
      //   submenu: [
           
      //     {
      //       title: 'Teacher Meetings',
      //       icon: <UserRoundPen   />,
      //       to: '/TeacherMeeting',
      //     },
      //     {
      //       title: 'Parents Meeting',
      //       icon: <UsersRound  />,
      //       to: '/ParentMeetings',
      //     },
      //     {
      //       title: 'Non-Teaching Staff',
      //       icon: <UserRoundX  />,
      //       to: '/NonTeachingStaffMeetings',
      //     },
          
      //   ],
      // },
      {
        title: 'Digital Classes',
        icon: <Bell />,
        to: '/DigitalClasses',
      },
      
      
    ],


  "/TransportDashboard":[
      
        {
          title: 'Scheduling Route',
          icon: <Clock4  />,
          to: '/SchedulingRouteList',
        },
         {
          title: 'Trips',
          icon: <Bus  />,
          to: '/Trips',
        },
        {
          title: 'Drivers',
          icon: <UserCog  />,
          to: '/DriversList',
        },
        {
          title: 'Student Bus List',
          icon: <UserPen  />,
          to: '/TotalBusAttendanceList',
          submenu: [
           
            {
              title: 'Present Students',
              icon: <UserPlus  />,
              to: '/PresentBusAttendeesList',
            },
            {
              title: 'Absent Students',
              icon: <UserMinus  />,
              to: '/AbsentBusAttendeesList',
            },
            
          ],
        },
        {
          title: 'Bus Fees',
          icon: <Bus />,
          to: '/BusFeesDetailsList',
          submenu: [
           
            {
              title: 'Paid Bus Fees',
              icon: <FaRupeeSign />,
              to: '/PaidBusFeeList',
            },
            {
              title: 'UnPaid Bus Fees',
              icon: <DoNotDisturbAltIcon />,
              to: '/UnpaidBusFeeList',
            },
            
          ],
        },
        {
          title: 'Bus Expenses',
          icon: <AssuredWorkloadIcon  />,
          to: '/BusExpenses',
        },
      
    ],


  };

  const titleMap = {
    "/StoreDashboard": "Store",
    "/ExaminationDashboard": "Examination",
    "/Dashboard": "HRBP",
    "/Admission_DashBoard": "Admission",
    "/ScheduleAndMeetDashboard": "Schedules",
    "/TransportDashboard": "Transport",
    "/PrincipalDashboard": "Principal",
  };



  const handleSubmenuToggle = (index) => {
    setOpenSubmenu((prev) => (prev === index ? null : index)); // Toggle submenu
  };



  const handleSubmenuChange = (event) => {
    const { value } = event.target;
  
    // If same submenu item is selected, reset it
    if (value === selectedSubmenu) {
      setSelectedSubmenu(""); // Reset selected submenu to force re-render
      setTimeout(() => {
        setSelectedSubmenu(value); // Re-select the same submenu after reset
      }, 0);
    } else {
      setSelectedSubmenu(value);
    }
  
    setTitle(titleMap[value] || "Principal"); // Default to "Principal" if no match
    setOpenSubmenu(null);
    navigate(value);
  };
  
  

  
  const handleItemClick = (index) => {
    setSelectedMenuItem(index);
  };

  

  // Update sessionStorage whenever selectedSubmenu changes
useEffect(() => {
  sessionStorage.setItem("selectedSubmenu", selectedSubmenu);
}, [selectedSubmenu]);

useEffect(() => {}, [location.pathname]);



  return (
  
    <Box
      sx={{
        position: "sticky",
        display: "flex",
        height: "100vh",
        top: 0,
        zIndex: 10000,
      }}
    >
     
      <GlobalStyles
     styles={{
      '.custom-sidebar-scrollbar': {
        // Firefox scrollbar width
        scrollbarWidth: '1px', // Adjust width for Firefox
        scrollbarColor: '#A5B5B6 #e0e0e0', // Change the thumb color to blue, track to #e0e0e0
  
        // Webkit scrollbar styles (Chrome, Safari, etc.)
        '&::-webkit-scrollbar': {
          width: '2px', // Adjust width for Webkit browsers
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'blue', // Thumb color (the part you drag)
          borderRadius: '4px', // Optional: makes the thumb rounded
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#A5B5B6', // Track color
          borderRadius: '4px', // Optional: makes the track rounded
        },
      },
  
  }}
/>



      <Sidebar
      className="custom-sidebar-scrollbar"
        breakPoint="md"
        style={{
          height: "100%",
          width: collapsed ? "80px" : "250px",
          transition: "width 0.3s ease-in-out",
        }}
        backgroundColor="#3C3972"
        // background= 'linear-gradient(135deg, #1976d2, #42a5f5)'
        // backgroundColor="#148C91"

       
      >
         {/* Collapse Button */}
      <Box sx={{ mb: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <IconButton
          onClick={broken ? () => toggleSidebar() : () => collapseSidebar()}
          sx={{ color: 'white', marginRight: '22px', '&:hover': { backgroundColor: '#3b4d7d' } }}
        >
          {collapsed ? <MenuIcon /> : <CloseIcon />}
        </IconButton>
      </Box>

       

        {/* Company Logo */}
        {!collapsed && (
          <Box mb="25px" mt={1} textAlign="center">
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              {loading ? (
                <CircularProgress sx={{ color: "black", mb: 2 }} />
              ) : (
                <Avatar
                  alt="Company Logo"
                  src={
                    companyInfo.schoolLogo
                      ? `data:image/jpeg;base64,${companyInfo.schoolLogo}`
                      : ""
                  }
                  sx={{ width: "100px", height: "100px", borderRadius: "50%" }}
                />
              )}
              {!loading && (
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  sx={{ mt: 1, color: "white" }}
                >
                  {companyInfo.schoolName}
                </Typography>
              )}
            </Box>
          </Box>
        )}

        {/* Menu Items */}
        <Menu
          iconShape="square"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            "&:hover" : {
              backgroundColor:"pink"
            }
            
          }}
        >
          <div>
            {menuItems[role]?.map((menuItem, index) => (
              

              <div key={index}>
                
                <MenuItem
                 disableRipple
                 
                 sx={{
                  color: "#fff",
                  padding: "12px 20px",
                  borderRadius: "10px",
                  
                 // Active background
                  "&:hover": {
                    backgroundColor: "#3C3972 !important", // Keep hover effect same as active
                    color: "white !important",
                  },
                }}
                  
                  onClick={() => {
                    // handleItemClick(index); // Update selected item
                    if (menuItem.submenu) {
                      handleSubmenuToggle(index);
                      navigate(menuItem.to);
                      
                    } else {
                      navigate(menuItem.to);
                    }
                  }}
                >
                  
  <Box
  sx={{
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "10px", // Optional for spacing
    borderRadius: "5px", // Optional for rounded corners
    backgroundColor: location.pathname === menuItem.to ? "#6461A9" : "none", 
    color: location.pathname === menuItem.to ? "white" : "none", // Active text color
    // Default text color
    // color: selectedMenuItem === index ? '#2C3A74' : '#E2EAF4',
    // backgroundColor:  selectedMenuItem === index ? 'red' :"none",
    "&:hover": {
      // backgroundColor: "white",
      color: "white", // Text color for Typography on hover
    },
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      color: "white", // Inherit default Box color
      "&:hover": {
        color: "white", // Prevent hover color change for the icon
      },
     
    }}
  >
    {menuItem.icon}
  </Box>
  <Typography
    variant="body2"
    sx={{
      marginLeft: "10px",
      fontSize: "17px",
      fontWeight: "1000",
      
      color: "inherit", // Inherit color from parent Box
      // color: selectedMenuItem === index ? 'red' : 'inherit',
      transition: "color 0.1s", // Smooth transition for text color
    }}
  >
    {menuItem.title}
  </Typography>
  {menuItem.submenu && (
    <span style={{ marginLeft: "auto" }}>
      {openSubmenu === index ? <ExpandLess /> : <ExpandMore />}
    </span>
  )}
</Box>


                </MenuItem>

                {/* Submenu */}
                {menuItem.submenu && (
  <Collapse in={openSubmenu === index} timeout="auto">
    {role === "PRINCIPAL" ? (
      
      <RadioGroup
        // value={selectedSubmenu}
        onChange={handleSubmenuChange}
        sx={{ pl: 4, pt: 1, pb: 1,color:'white', marginLeft:'10px',}}
        key={selectedSubmenu} // Add key prop to force re-render when submenu changes
      >
        {menuItem.submenu.map((subItem, subIndex) => (
          <FormControlLabel
            key={subIndex}
            value={subItem.to}
            control={
            <Radio 
              // sx={{color:'#fff'}}

            />
          }
            // control={<Radio sx={{color:'#fff'}}/>}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "white", // Default text color
                  padding: "10px",
                  borderRadius: "5px",
                  backgroundColor:
                  location.pathname === subItem.to ? "#6461A9" : "none",
                  color:location.pathname === subItem.to ? "white" : "none"
                  
                
                }}
              >
                {/* {subItem.icon} */}
                <Typography
                  variant="body2"
                  sx={{
                    marginLeft: "2px",
                    fontSize: "17px",
                    fontWeight: "1000",
                    color: "white", // Inherit color from parent Box
                    transition: "color 0.1s", // Smooth transition for text color
                    
                  }}
                >
                  {subItem.title}
                </Typography>
              </Box>
            }
            sx={{
              "& .MuiTypography-root": {
                fontSize: "14px",
                color: "white",
                // transition: "background-color 0.3s, color 0.3s", // Smooth transitions
               
              },
            }}
          />
        ))}
      </RadioGroup>
      
    ) : (
      menuItem.submenu.map((subItem, subIndex) => (
        <MenuItem
          key={subIndex}
          sx={{
            padding: "12px 20px", // Match main MenuItem padding
            borderRadius: "10px", // Match main MenuItem border radius
            // "&:hover": { backgroundColor: "lightgray" }, // Hover effect
          }}
          // onClick={() => navigate(subItem.to)}
          onClick={() => {
            // handleItemClick(subIndex); // Update selected item
            navigate(subItem.to);   // Navigate to the desired route
          }}
        >
          <Box
            sx={{
              marginLeft: "40px",
              display: "flex",
              alignItems: "center",
              width: "80%",
              borderRadius: "5px  !important",
              padding: "10px",
              transition: "background-color 0.3s, color 0.3s", // Smooth transitions
               color: "white", // Default text color
               backgroundColor:
               location.pathname === subItem.to ? "#6461A9" : "none",
           
            }}
          >
            <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "white", // Inherit default Box color
                  "&:hover": {
                    color: "inherit", // Prevent hover color change for the icon
                  },
                  
                }}
              >
                {subItem.icon} 
              </Box>
             
            <Typography
              variant="body2"
              sx={{
                marginLeft: "7px",
                fontSize: '13px', // Match font size with main menu item
                fontWeight: "1000",
                color: "inherit", // Inherit color from parent Box
                transition: "color 0.1s", // Smooth transition for text color
              }}
            >
              {subItem.title}
            </Typography>
          </Box>
        </MenuItem>
      ))
    )}
  </Collapse>
)}

              </div>
            ))}

            {/* Related Menu Items (Only for Organization role) */}
            {role === "PRINCIPAL" &&
              selectedSubmenu &&
              relatedItems[selectedSubmenu]?.map((item, idx) => (
                <div key={idx}>
                  <MenuItem
                    onClick={() => {
                      handleItemClick(idx); // Update selected item
                      if (item.submenu) {
                        // handleItemClick(idx); 
                        navigate(item.to);
                        handleSubmenuToggle(idx); // Toggle submenu visibility
                      } else {
                        navigate(item.to); // Navigate if there's no submenu
                      }
                    }}
                    sx={{
                      color: "#000",
                      padding: "10px",
                      borderRadius: "8px",
                      "&:hover": { backgroundColor: "lightgray" },
                      display: "flex",
                      justifyContent: "space-between", // Space for the icon
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "10px", // Optional for spacing
                        borderRadius: "5px", // Optional for rounded corners
                        backgroundColor:
                        location.pathname === item.to ? "#6461A9" : "none",
                        transition: "background-color 0.3s, color 0.3s", // Smooth transitions
                        color: location.pathname === item.to ? "white" : "none", // Default text color
                        // color: selectedMenuItem === idx ? '#2C3A74' : '#E2EAF4',
                        // backgroundColor:  selectedMenuItem === idx ? 'white' :"none",
                        
                      }}
                    >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              color: "white", // Inherit default Box color
             
            }}
          >
            {item.icon}
          </Box>
          <Typography
            variant="body2"
            sx={{
              marginLeft: "10px",
              fontSize: "17px",
              fontWeight: "1000",
              color: "inherit", // Inherit color from parent Box
              transition: "color 0.1s", // Smooth transition for text color
            }}
          >
            {item.title}
          </Typography>
          {item.submenu && (
            <IconButton size="small" sx={{ paddingLeft: 3,color:'white' }}>
              {openSubmenu === idx ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          )}
        </Box>
      </MenuItem>

      {item.submenu && (
        
        <Collapse in={openSubmenu === idx} timeout="auto" unmountOnExit>
          <Box sx={{ paddingLeft: "30px" }}>
            {item.submenu.map((subItem, subIndex) => (
              <MenuItem
                key={subIndex}
                sx={{
                  color: "#000",
                  padding: "10px",
                 
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {
                  // handleItemClick(subIndex); // Update selected item
                  navigate(subItem.to);
                  // Keep the submenu open after navigating
                  // handleSubmenuToggle(idx);
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    padding: "10px", // Optional for spacing
                    borderRadius: "5px", // Optional for rounded corners
                    transition: "background-color 0.3s, color 0.3s", // Smooth transitions
                    backgroundColor:
                    location.pathname === subItem.to ? "#6461A9" : "none",
                    color: location.pathname === item.to ? "white" : "none", // Default text color
                    // color: selectedMenuItem === subIndex ? '#2C3A74' : '#E2EAF4',
                    // backgroundColor: selectedMenuItem === subIndex ? 'white' :"none",

                    
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color: "white", // Inherit default Box color
                    
                    }}
                  >
                    {subItem.icon}
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      marginLeft: "7px",
                      fontSize: "12px",
                      fontWeight: "1000",
                      color: "white", // Inherit color from parent Box
                      transition: "color 0.1s", // Smooth transition for text color
                    }}
                  >
                    {subItem.title}
                  </Typography>
                </Box>
              </MenuItem>
            ))}
          </Box>
        </Collapse>
        
      )}
    </div>
            ))}

          </div>
        </Menu>
      </Sidebar>
      
    </Box>
    
  );
};

export default MyProSidebar;